if (typeof customElements.get('shop-the-look-slider') === 'undefined') {
	class ShopTheLook extends HTMLElement {
		constructor() {
			super();

			this.slider = this.querySelector(
				'.shop-the-look-slider__slider'
			);

			this.slides = this.slider
				? this.slider.querySelectorAll('.splide__slide')
				: [];

			this.focalPoints = this.querySelectorAll(
				'.shop-the-look-slider__image-point'
			);

			this.showPagination =
				this.slider?.dataset.showPagination !== 'false';

			this.classes = {
				activePoint:
					'shop-the-look-slider__image-point--active',
			};

			this.splide = null;

			this.init();
		}

		init() {
			if (!this.slider) return;

			this.initSlider();
			this.initFocalPoints();
		}

		initSlider() {
			if (this.slides.length < 2) return;

			this.splide = new Splide(this.slider, {
				type: 'loop',
				perPage: 2,
				perMove: 1,
				gap: '12px',
				drag: true,
				arrows: true,
				pagination: this.showPagination,
				lazyLoad: 'nearby',

				breakpoints: {
					768: {
						perPage: 2,
						perMove: 1,
						gap: '8px',
					},
				},
			});

			this.splide.on('moved', (newIndex) => {
				this.setActiveFocalPoint(newIndex);
			});

			this.splide.mount();
		}

		initFocalPoints() {
			this.setActiveFocalPoint(0);

			this.focalPoints.forEach((focalPoint, index) => {
				const goToProduct = (event) => {
					event.preventDefault();

					if (this.splide) {
						this.splide.go(index);
					}
				};

				focalPoint.addEventListener(
					'click',
					goToProduct
				);

				focalPoint.addEventListener(
					'touchstart',
					goToProduct,
					{
						passive: false,
					}
				);
			});
		}

		setActiveFocalPoint(activeIndex) {
			if (!this.focalPoints.length) return;

			const normalizedIndex =
				((activeIndex % this.focalPoints.length) +
					this.focalPoints.length) %
				this.focalPoints.length;

			this.focalPoints.forEach(
				(focalPoint, index) => {
					focalPoint.classList.toggle(
						this.classes.activePoint,
						index === normalizedIndex
					);
				}
			);
		}

		disconnectedCallback() {
			if (this.splide) {
				this.splide.destroy();
			}
		}
	}

	customElements.define(
		'shop-the-look-slider',
		ShopTheLook
	);
}